import { render, staticRenderFns } from "./SchemeEditor.vue?vue&type=template&id=6e46182a&"
import script from "./SchemeEditor.vue?vue&type=script&lang=js&"
export * from "./SchemeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports